export const index = {
  path   : '/dashboard/',
  method : 'GET',
  version: '/v1'
}
